import { Tooltip as KobalteTooltip } from "@kobalte/core/tooltip"
import type { AccentHue } from "@repo/fika-design-system/color"
import { type ParentProps, Show } from "solid-js"
import { Box } from "./box"
import { Text } from "./text"
import { tooltipContentRecipe, tooltipTriggerClass } from "./tooltip.css"

type Placement = "top" | "bottom" | "left" | "right"

type Props = ParentProps & {
  title?: string
  description: string
  shortcut?: string
  dark?: boolean
  placement?: Placement
  hue?: AccentHue
  tooltipTriggerClass?: string
  ignoreSafeArea?: boolean
}
export function Tooltip(props: Props) {
  return (
    <Show when={props.description} fallback={props.children}>
      <KobalteTooltip
        gutter={12}
        placement={props.placement ?? "top"}
        openDelay={0}
        closeDelay={0}
        skipDelayDuration={0}
        ignoreSafeArea={props.ignoreSafeArea ?? false}
      >
        <KobalteTooltip.Trigger
          class={[tooltipTriggerClass, props.tooltipTriggerClass].join(" ")}
          tabIndex={-1}
          type="button"
        >
          {props.children}
        </KobalteTooltip.Trigger>
        <KobalteTooltip.Portal>
          <KobalteTooltip.Content
            class={tooltipContentRecipe({
              hue: props.hue ?? "sand",
              dark: true,
            })}
          >
            <Box>
              <Show when={props.title}>
                {title => (
                  <Text fontSize="m" color="base0" fontWeight="500">
                    {title()}
                  </Text>
                )}
              </Show>
              <Box flexDirection="row" alignItems="center" gap="8">
                <Text fontSize="s" color="sand50">
                  {props.description}
                </Text>
                <Show when={props.shortcut}>
                  {shortcut => (
                    <Text fontSize="s" color="sand400">
                      {shortcut()}
                    </Text>
                  )}
                </Show>
              </Box>
            </Box>
          </KobalteTooltip.Content>
        </KobalteTooltip.Portal>
      </KobalteTooltip>
    </Show>
  )
}
